import { FormHelperText, styled } from '@mui/material';

export const ErrorMessageText = styled(FormHelperText)`
  margin-top: 0;
`;
